exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0; }\n\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto; }\n\n:focus {\n  outline: 0; }\n", ""]);

// exports
